import _styled from "styled-components";
import React from "react";

var IconContainer = _styled.div.withConfig({
  displayName: "ConfirmButton__IconContainer",
  componentId: "sc-1daud69-0"
})([""]);

var ButtonStyled = _styled.button.withConfig({
  displayName: "ConfirmButton__ButtonStyled",
  componentId: "sc-1daud69-1"
})(["border:none;background-color:transparent;outline:none;"]);

var ButtonLabel = _styled.div.withConfig({
  displayName: "ConfirmButton__ButtonLabel",
  componentId: "sc-1daud69-2"
})(["display:flex;flex-direction:column;font-size:20px;width:130px;margin-top:15px;"]);

export function ConfirmButton(_ref) {
  var buttonLabel = _ref.buttonLabel,
      onClick = _ref.onClick,
      children = _ref.children;
  return /*#__PURE__*/React.createElement(ButtonStyled, {
    onClick: onClick
  }, /*#__PURE__*/React.createElement(IconContainer, null, children), /*#__PURE__*/React.createElement(ButtonLabel, null, buttonLabel));
}